import React from 'react'

import _modules from '../../../../_modules'

const Suppliers = React.lazy(() => import('./views/suppliers/Suppliers'))
const SuppliersDetail = React.lazy(() => import('./views/suppliers/SuppliersDetail'))
const SupplierTypes = React.lazy(() => import('./views/supplierTypes/SupplierTypes'))
const SupplierTypesDetail = React.lazy(() => import('./views/supplierTypes/SupplierTypesDetail'))
const SupplierChannels = React.lazy(() => import('./views/supplierChannels/SupplierChannels'))
const SupplierChannelsDetail = React.lazy(() =>
  import('./views/supplierChannels/SupplierChannelsDetail'),
)
const ContactPeople = React.lazy(() => import('./views/contactPeople/ContactPeople'))
const ContactPeopleDetail = React.lazy(() => import('./views/contactPeople/ContactPeopleDetail'))

const _routes = []

_routes.push(
  ...[
    {
      path: '/suppliers/supplier-types/:id',
      name: 'Supplier Types Detail',
      component: SupplierTypesDetail,
    },
    { path: '/suppliers/supplier-types', name: 'Supplier Types', component: SupplierTypes },
  ],
)
_routes.push(
  ...[
    {
      path: '/suppliers/supplier-channels/:id',
      name: 'Supplier Channels Detail',
      component: SupplierChannelsDetail,
    },
    {
      path: '/suppliers/supplier-channels',
      name: 'Supplier Channels',
      component: SupplierChannels,
    },
  ],
)
if (_modules.contact_people)
  _routes.push(
    ...[
      {
        path: '/suppliers/contact-people/:id',
        name: 'Contact People Detail',
        component: ContactPeopleDetail,
      },
      { path: '/suppliers/contact-people', name: 'Contact People', component: ContactPeople },
    ],
  )
if (_modules.suppliers)
  _routes.push(
    ...[
      { path: '/suppliers/:id', name: 'Suppliers Detail', component: SuppliersDetail },
      { path: '/suppliers', name: 'Suppliers', component: Suppliers },
    ],
  )

export default _routes
